import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Fingerprint, ArrowRight, Shield, Zap, Bell } from 'lucide-react';
import { useI18n } from '@/lib/i18n';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import { MAIN_APP_URL } from '@/lib/constants';

export default function LoginPage() {
    const { t } = useI18n();
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (isAuthenticated) navigate('/', { replace: true });
    }, [isAuthenticated]);

    const loginWithSatutim = () => {
        setBusy(true);
        const returnTo = `${window.location.origin}/auth/sso`;
        const url = `${MAIN_APP_URL}/auth/sso?return_to=${encodeURIComponent(returnTo)}`;
        window.location.href = url;
    };

    return (
        <div className="min-h-[100dvh] flex flex-col bg-gradient-to-b from-brand to-brand-700 text-white">
            <div className="flex-1 flex flex-col justify-center px-6 py-12 max-w-md w-full mx-auto">
                <div className="text-center mb-10">
                    <div className="inline-flex h-20 w-20 rounded-3xl bg-white/20 backdrop-blur items-center justify-center mb-5 shadow-lg">
                        <Fingerprint className="h-10 w-10 text-white" />
                    </div>
                    <h1 className="text-3xl font-black mb-2">{t('auth.login_title')}</h1>
                    <p className="text-sm opacity-85 max-w-[280px] mx-auto">{t('auth.login_subtitle')}</p>
                </div>

                <div className="bg-white text-gray-900 rounded-3xl p-6 shadow-2xl">
                    <Button
                        onClick={loginWithSatutim}
                        disabled={busy}
                        size="xl"
                        className="w-full text-base"
                    >
                        {busy ? t('auth.sso.exchanging') : (
                            <>
                                <Fingerprint className="h-5 w-5 mr-2" />
                                {t('auth.login_with_satutim')}
                                <ArrowRight className="h-4 w-4 ml-2" />
                            </>
                        )}
                    </Button>

                    <p className="text-[11px] text-gray-500 text-center mt-3">{t('auth.login_with_satutim_hint')}</p>

                    <div className="mt-6 pt-6 border-t border-gray-100 space-y-3">
                        <Feature icon={Shield} text={t('auth.feature_secure')} />
                        <Feature icon={Zap} text={t('auth.feature_fast')} />
                        <Feature icon={Bell} text={t('auth.feature_notif')} />
                    </div>
                </div>

                <p className="text-xs text-center text-white/80 mt-6">
                    {t('auth.no_account')}{' '}
                    <a href={MAIN_APP_URL} className="font-bold text-white underline">satutim.id</a>
                </p>
            </div>
        </div>
    );
}

function Feature({ icon: Icon, text }: { icon: any; text: string }) {
    return (
        <div className="flex items-center gap-2.5">
            <div className="h-7 w-7 rounded-lg bg-brand/10 flex items-center justify-center shrink-0">
                <Icon className="h-3.5 w-3.5 text-brand-700" />
            </div>
            <p className="text-xs text-gray-600">{text}</p>
        </div>
    );
}
